// material-ui
import { Theme } from "@mui/material/styles"

// project-imports
import getColors from "utils/getColors"

// types
import { ExtendedStyleProps } from "types/extended"

// ==============================|| BADGE - COLORS ||============================== //

function getColorStyle({ color, theme }: ExtendedStyleProps) {
    const colors = getColors(theme, color)
    const { darker, lighter } = colors
    return {
        color: darker,
        backgroundColor: lighter,
    }
}

// ==============================|| OVERRIDES - BADGE ||============================== //

export default function Badge(theme: Theme) {
    const defaultLightBadge = getColorStyle({ color: "primary", theme })
    return {
        MuiBadge: {
            styleOverrides: {
                standard: {
                    minWidth: theme.spacing(2),
                    height: theme.spacing(2),
                    padding: theme.spacing(0.5),
                    "&.MuiBadge-colorWarning": {
                        color: theme.palette.warning.contrastText,
                        backgroundColor: theme.palette.warning.main,
                    },
                },
                colorSecondary: {
                    color: theme.palette.secondary.lighter,
                },
                light: {
                    ...defaultLightBadge,
                    "&.MuiBadge-colorPrimary": getColorStyle({
                        color: "primary",
                        theme,
                    }),
                    "&.MuiBadge-colorSecondary": getColorStyle({
                        color: "secondary",
                        theme,
                    }),
                    "&.MuiBadge-colorError": getColorStyle({
                        color: "error",
                        theme,
                    }),
                    "&.MuiBadge-colorInfo": getColorStyle({
                        color: "info",
                        theme,
                    }),
                    "&.MuiBadge-colorSuccess": getColorStyle({
                        color: "success",
                        theme,
                    }),
                    "&.MuiBadge-colorWarning": getColorStyle({
                        color: "warning",
                        theme,
                    }),
                },
            },
        },
    }
}
